export function addCurrent(organization) {
//    console.log('organization');

    return {
        type: 'ADD_CURRENT',
        organization,
    }
}
